/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import * as React from 'react';

interface INotificationProps {
    level?: string;
}

function Notification(props: React.PropsWithChildren<INotificationProps>) {
    let contentClass = 'apmui-notification';
    if (props.level) {
        contentClass += ' notification-' + props.level;
    }

    return (
        /* FIXME: create portal to document.body or apmui-container */
        <div className="apmui-notification--container">
            <div className={contentClass}>
                <div className="apmui-notification--content">{props.children}</div>
            </div>
        </div>
    );
}

export default Notification;
